<template>
  <div class="__dropdown" ref="dropdown" v-click-outside="clickOutsideEvent">
    <button class="__dropdown_btn" @click="isDropdown = !isDropdown">
      <slot></slot>
      <span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.94 5.89355L8 8.94689L11.06 5.89355L12 6.83355L8 10.8336L4 6.83355L4.94 5.89355Z"
            fill="#23313E"
          />
        </svg>
      </span>
    </button>
    <div class="__dropdown_content" v-if="isDropdown">
      <a
        class="__dropdown_item"
        v-for="(option, index) in options"
        :key="index"
        :class="option.color"
        @click="$emit('select', option.text)"
      >
        {{ option.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isDropdown: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    clickOutsideEvent() {
      this.isDropdown = false
    }
  }
};
</script>

<style lang="scss" scoped>
.text-danger {
  color: #dc2323;
}

.__dropdown_btn {
  background: #ffffff;
  border: 1px solid #c7c9d1;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  color: #23313e;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 14px;
  height: 44px;
}

.__dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}

.__dropdown_content {
  position: absolute;
  transform: translate(0, 8px);
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  min-width: 160px;
  z-index: 1;

  .__dropdown_item {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    width: 199px;
    height: 44px;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
  > .__dropdown_item:not(:first-child) {
    border-top: 1px solid #ddd;
  }
}

.__dropdown_content a:hover {
  background-color: #f1f1f1;
}

.__dropdown:hover .__dropdown_btn {
  background-color: #ffffff;
}
</style>